import React from 'react';
import { Segment, Table, Loader, Header, Grid, Divider } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import ThreeColumnTableRow from '../../../../Admin/CreateCourse/ThreeColumnTableRow';
import request from '../../Util/request';
import { Redirect } from 'react-router-dom';
import HeaderSubHeader from 'semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

const NoDataMessage = () => <p>Nema kandidata.</p>;

export default class CommitteeDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            candidate: '',
            info: {},
            candidates: [],
            members: [],
            candidateOptions: [1],
            showAddCandidates: false,
            infoLoader: true,
            membersLoader: true,
            candidatesLoader: true
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getCommitteeMembersByCommitteeId = this.getCommitteeMembersByCommitteeId.bind(this);
        this.getCommitteeCandidatesByCommitteeId = this.getCommitteeCandidatesByCommitteeId.bind(this);
    }

    UNSAFE_componentWillMount() {
        let committeeId = localStorage.getItem('committeeId');
        this.getCommitteeInfoCommitteeId(committeeId);
        this.getCommitteeMembersByCommitteeId(committeeId);
        this.getCommitteeCandidatesByCommitteeId(committeeId);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    getCommitteeInfoCommitteeId(committeeId) {
        axios.get(`/committee/${committeeId}`)
            .then(res => {
                let info = res.data;
                this.setState({ info, infoLoader: false });
            });
    }
    getCommitteeMembersByCommitteeId(committeeId) {
        request.fetchCommitteeMembersByCommitteeId(committeeId).then(members => this.setState({ members, membersLoader: false })).catch(err => {
            console.log('Failed to fetch committee members.');
        });
    }

    getCommitteeCandidatesByCommitteeId(committeeId) {
        axios.get(`/committee/${committeeId}/candidates`)
            .then(res => {
                let candidates = res.data;

                this.setState({ candidates, candidatesLoader: false });
            });
    }

    render() {
        if (this.state.showCandidateInfo === true) {
            return <Redirect push to={{ pathname: '/ekvivalencija-ispita/prikaz-kandidata/detalji', state: { student: 1 } }} />;
        }
        return (
            <div>
                <h1> Detalji </h1>
                <Grid columns="equal" centered className="stackable">
                    <Grid.Column>
                        <Segment.Group raised clearing>
                            <Segment>
                                <Header as="h3">
                                    Osnovne informacije o komisiji
                                    <HeaderSubHeader>Nije moguće brisati/mijenjati komisiju koja je već zadužena za kandidate.</HeaderSubHeader>
                                </Header>
                            </Segment>

                            <Segment clearing>
                                <div>
                                    <Table celled unstackable compact>
                                        { this.state.infoLoader ? <Loader active inline="centered" /> :
                                        <Table.Body>
                                                <ThreeColumnTableRow
                                                    name="Tip komisije"
                                                    keyName="optionalCoursesNumberMin"
                                                    value={this.state.info.committeeType}
                                                    onChange={this.onChange}
                                                    edit={this.state.edit}
                                            />
                                                <ThreeColumnTableRow
                                                    name="Broj odluke"
                                                    keyName="optionalCoursesECTSMin"
                                                    value={this.state.info.decisionNumber}
                                                    onChange={this.onChange}
                                                    edit={this.state.edit}
                                            />
                                                <ThreeColumnTableRow
                                                    name="Datum odluke"
                                                    keyName="optionalCoursesECTSMax"
                                                    value={moment(this.state.info.decisionDate).format('D. M. YYYY.')}
                                                    onChange={this.onChange}
                                                    edit={this.state.edit}
                                            />

                                                <ThreeColumnTableRow
                                                    name="Akademska godina"
                                                    keyName="optionalCoursesNumberMax"
                                                    value={this.state.info.academicYear}
                                                    onChange={this.onChange}
                                                    edit={this.state.edit}
                                            />
                                            </Table.Body>}
                                    </Table>
                                    <br />
                                </div>
                                <Grid columns="equal" centered className="stackable" >
                                    <Grid.Column>
                                        <Divider horizontal>
                                            <Header as="h3">
                                                Članovi komisije
                                            </Header>
                                        </Divider>

                                        { this.state.membersLoader ? <Loader active inline="centered" /> : this.state.members.length ?
                                            <div>
                                                <Table celled selectable compact >

                                                    <Table.Header>
                                                        <Table.Row >
                                                            <Table.HeaderCell>Ime</Table.HeaderCell>
                                                            <Table.HeaderCell>Prezime</Table.HeaderCell>
                                                            <Table.HeaderCell>Organizaciona jedinica</Table.HeaderCell>


                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                        {this.state.members.map((el, index) =>
                                                            (<Table.Row
                                                                key={index}
                                                                positive={el.committeeMemberTypeKey === 'head'}
                                                            >
                                                                <Table.Cell verticalAlign="middle">
                                                                    {el.firstName}
                                                                </Table.Cell>
                                                                <Table.Cell verticalAlign="middle">
                                                                    {el.lastName}
                                                                </Table.Cell>
                                                                <Table.Cell verticalAlign="middle">
                                                                    {el.organizationalUnit}
                                                                </Table.Cell>

                                                            </Table.Row>))}
                                                    </Table.Body>

                                                </Table>
                                            </div>

                                            : <NoDataMessage />
                                        }

                                    </Grid.Column>
                                    <Grid.Column>

                                        <Divider horizontal>
                                            <Header as="h3">
                                                Kandidati
                                            </Header>
                                        </Divider>

                                        {this.state.candidatesLoader ? <Loader active inline="centered" /> : this.state.candidates.length ?
                                            <div>

                                                <Table celled selectable compact >

                                                    <Table.Header>
                                                        <Table.Row >
                                                            <Table.HeaderCell>Ime</Table.HeaderCell>
                                                            <Table.HeaderCell>Prezime</Table.HeaderCell>
                                                            {/* <Table.HeaderCell>Organizaciona jedinica</Table.HeaderCell> */}

                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                        {this.state.candidates.map((el, index) =>
                                                            (<Table.Row
                                                                key={index}

                                                                onClick={(e) => {
                                                                    localStorage.setItem('candidateId', el.candidateId);
                                                                    localStorage.setItem('candidateEquivalenceStatus', el.status);
                                                                    localStorage.setItem('candidateFirstName', el.firstName);
                                                                    localStorage.setItem('candidateLastName', el.lastName);
                                                                    localStorage.setItem('showAddButton', 'yes');
                                                                    this.setState({ showCandidateInfo: true });
                                                                }}
                                                                // treba da redirecta na detalji o kandidatima

                                                            >
                                                                <Table.Cell verticalAlign="middle">
                                                                    {el.firstName}
                                                                </Table.Cell>
                                                                <Table.Cell verticalAlign="middle">
                                                                    {el.lastName}
                                                                </Table.Cell>
                                                                {/* <Table.Cell verticalAlign="middle"> */}
                                                                {/*    {'mkj'} */}
                                                                {/* </Table.Cell> */}

                                                            </Table.Row>))}
                                                    </Table.Body>

                                                </Table>
                                            </div>

                                            : <NoDataMessage />

                                        }

                                    </Grid.Column>
                                </Grid>

                            </Segment>


                        </Segment.Group>
                    </Grid.Column>
                </Grid>


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Comitee/CommitteeDetails/CommitteeDetails.js